export enum NFC_WS_STATUS {
    READER_STATUS = "READER_STATUS",
    CARD_STATUS = "CARD_STATUS",
    DATA_READ_SUCCESS = "DATA_READ_SUCCESS",
    DATA_READ_ERROR = "DATA_READ_ERROR",
    READER_ERROR = "READER_ERROR",
    GET_READER_STATUS = "GET_READER_STATUS",
    WRITE_DATA = "WRITE_DATA",
    DATA_WRITE_SUCCESS = "DATA_WRITE_SUCCESS",
    DATA_WRITE_ERROR = "DATA_WRITE_ERROR"
}